import { render } from "./DeleteAccountPage.vue?vue&type=template&id=711afc72&ts=true"
import script from "./DeleteAccountPage.vue?vue&type=script&lang=ts"
export * from "./DeleteAccountPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__